<template>
  <div class="search-main">
    <div class="search-head">
      <input type="text" class="input-text" v-model="searchWord" @keyup="searchBooksFromLetter" placeholder="金のフレーズ">
      <a href="javascript:void(0);" @click="hideSearch" class="search-head__cancel">Cancel</a>
    </div>
    <app-loading v-if="isLoading"></app-loading>
    <div class="search-book-list" v-else>
      <a v-for="book in searchFilterddBooks" :href="'/books/' + book.id_book"  class="search-book-list__item">{{book.name_book}}</a>
    </div>
  </div>
</template>

<script>
  import Loading from '../common/Loading.vue';
  import _ from 'lodash';

  export default {
    data() {
      return {
        searchWord: '',
        searchBooks: [],
        searchFilterddBooks: [],
      }
    },
    created() {
      this.$store.dispatch("changeLoadingCondition", true);
      this.$http.get('webstore/book/titles')
        .then(res => {
          return res.json();
        }, err => {
          return err.json();
        })
        .then(data => {
          this.searchBooks = data.book_list;
          this.$store.dispatch("changeLoadingCondition", false);
        })
        .catch(() => {
          alert("検索データ一覧の取得に失敗しました。");
          this.$store.dispatch("changeLoadingCondition", false);
        });
    },
    watch: {
      searchWord() {
        this.searchBooksFromLetter();
      }
    },
    components: {
      appLoading: Loading
    },
    methods: {
      searchBooksFromLetter() {
        this.$store.dispatch("changeLoadingCondition", true);
        if (this.searchWord) {
          this.searchFilterddBooks = this.searchBooks.filter(obj => {
            return obj.name_book.toLowerCase().indexOf(this.searchWord.toLowerCase()) != -1;
          });
        } else {
          this.searchFilterddBooks = [];
        }
        this.$store.dispatch("changeLoadingCondition", false);
      },
      hideSearch() {
        this.$store.dispatch("toggleSearch", false);
      }
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/search/Search.vue